export type Route =
  | { kind: "library" }
  | { kind: "callback" }
  /** `chat` : ouvert depuis une discussion de la bibliothèque, le chat est affiché d'emblée. */
  | { kind: "read"; bookId: string; chat?: boolean }
  | { kind: "open" };

/** Routes du reader : bibliothèque, retour de connexion, lecture d'un livre, lien direct vers un manifest. */
export function route(pathname: string, search: string): Route {
  if (pathname === "/auth/callback") return { kind: "callback" };
  const read = pathname.match(/^\/lire\/([A-Za-z0-9_-]{1,64})\/?$/);
  if (read) return new URLSearchParams(search).has("discussion") ? { kind: "read", bookId: read[1]!, chat: true } : { kind: "read", bookId: read[1]! };
  if (new URLSearchParams(search).has("manifest")) return { kind: "open" };
  return { kind: "library" };
}
